// @ts-nocheck
import React from "react";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Radio } from "antd";
import { AmountRadio } from "../../Wrapper";
import { Box } from "src/components/Core/Box";
import { Field } from "src/components/Forms/Field";
import { FormikProps } from "formik";
import { FormikInputNumber } from "src/components/Forms/TextInputNumber";
import ClearButton from "./ClearButton";

interface Props {
  formProps: FormikProps<any>;
  collapsed: any;
  clearFilterKey: (key: string) => void;
}

const Followers: React.FC<Props> = ({
  formProps,
  collapsed,
  clearFilterKey,
}) => {
  const fieldValue = formProps?.values;

  let isVisible = false;
  let backgroundColor = "#FFFFFF";

  if (fieldValue?.followers !== 0) {
    isVisible = true;
    backgroundColor = "#FAFAFA";
  }

  return (
    <Box background={backgroundColor} padding="5px">
      <Field
        label="Followers:"
        mb={20}
        extra={
          <ClearButton
            isVisible={isVisible}
            buttonClick={() => {
              formProps?.setFieldValue("followers", 0);
              formProps?.setFieldValue("followersIsgreaterThan", true);
              clearFilterKey("followers");
            }}
          />
        }
      >
        <Box>
          <AmountRadio>
            <Radio.Button
              value={false}
              onChange={value => {
                if (fieldValue?.followers || fieldValue?.followers === 0) {
                  formProps?.setFieldValue("followersIsgreaterThan", false);
                }
              }}
              checked={fieldValue?.followersIsgreaterThan === false}
            >
              <LeftOutlined />
            </Radio.Button>
            <Radio.Button
              value={true}
              onChange={value => {
                if (fieldValue?.followers || fieldValue?.followers === 0) {
                  formProps?.setFieldValue("followersIsgreaterThan", true);
                }
              }}
              checked={fieldValue?.followersIsgreaterThan === true}
            >
              <RightOutlined />
            </Radio.Button>
          </AmountRadio>

          <FormikInputNumber
            parser={value => {
              let parsed = value.replace(/\[0-9]/g, "");
              if (parsed) {
                return parsed.match(/\d+/g) ? parseInt(parsed) : "";
              } else {
                return null;
              }
            }}
            name="followers"
            borderRadius={3}
            borderColor="grey5"
            size="small"
            value={fieldValue?.followers}
            style={{ marginLeft: 5, width: `${collapsed ? 72 : 105}px` }}
          />
        </Box>
      </Field>
    </Box>
  );
};

export default Followers;
